import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../../query-function';
import { bucketsKeys } from '../../cache-keys/bucketsKeys';

export function useBucket(id: string) {
  const api = useAPI();

  return useQuery({
    queryKey: [bucketsKeys.bucket(id)],
    queryFn: queryFunction(
      ace_api.getBucket(api),
      ({ queryKey: [{ id }] }) => ({ id }),
    ),
    enabled: id !== '' && api.token !== '',
  });
}
